var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgPeopleHome = function SvgSvgPeopleHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.39 11.606a6.825 6.825 0 0 0-5.1 2.37 4.971 4.971 0 0 0-2.15-4.069A4.888 4.888 0 0 1 14 9a4.994 4.994 0 0 1 4.39 2.606Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.5 23.5.5-6h2.5V14a5 5 0 1 0-10 0v3.5H3l.5 6h4ZM5.5 7.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 7.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14v1.83a5 5 0 1 0-10 0V14a5 5 0 1 1 10 0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.361 11.11a4.916 4.916 0 0 1 4.561.671c.482-.111.974-.17 1.468-.175A4.994 4.994 0 0 0 14 9a4.894 4.894 0 0 0-2.86.91c.473.327.886.733 1.221 1.2Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2.329a3.49 3.49 0 0 1 3.364 2.586C8.95 4.617 8.996 4.31 9 4a3.5 3.5 0 1 0-7 0c.004.31.05.617.136.915A3.49 3.49 0 0 1 5.5 2.329Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3.33a2.99 2.99 0 0 1 2.843 2.085 3 3 0 0 0-5.622-2.087 3 3 0 0 0-.064 2.087A2.99 2.99 0 0 1 14 3.33Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.5 23.5.5-6h2.5V14a5 5 0 1 0-10 0v3.5H3l.5 6h4ZM5.5 7.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM14 7.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
    stroke: "#191919",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.5 17.68-2 1.82M7.5 23.5l.5-6h2.5V14a5 5 0 1 0-10 0v3.5H3l.5 6h4ZM5.5 7.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM14 7.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM18.7 12.485a5 5 0 0 0-7.262-2.819",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 21v2.5h-3V21a1.5 1.5 0 1 1 3 0Z",
    fill: "#FF808C",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 17.68v5.82h-2V21a1.5 1.5 0 1 0-3 0v2.5h-2v-5.82L18 14.5l3.5 3.18Z",
    fill: "#fff",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.5 19.5-2-1.82M14.5 17.68l-2 1.82",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSvgPeopleHome;